import React, {Fragment, useEffect} from 'react';
import Alert from '@material-ui/lab/Alert';
import {connect} from 'react-redux';

/** Prefer userPermissions in localStorage; else Redux globalState (e.g. auth socket). */
export function getEffectivePermissionList(globalStatePermissions) {
    let raw = typeof localStorage !== 'undefined' ? localStorage.getItem('userPermissions') : null;
    let permissions;
    if (!raw || raw.length === 0) {
        permissions = globalStatePermissions || [];
        if (!Array.isArray(permissions)) {
            permissions = permissions
                ? String(permissions).split(',').map((item) => item.trim()).filter(Boolean)
                : [];
        }
    } else {
        permissions = String(raw).split(',').map((item) => item.trim()).filter(Boolean);
    }
    return Array.isArray(permissions) ? permissions : [];
}

const AccessControl = props => {

    useEffect( () => {

    });

    let fallback = props.fallback || null;
    let permissions = getEffectivePermissionList(props.globalState.permissions);

    let requiredPermissions = props.required || ['noAccess'];
    if ( !Array.isArray(requiredPermissions) ) requiredPermissions = requiredPermissions.split(',').filter(item => item.trim());

    let matchType = props.match || 'all';
    let allowed = false;
    if ( matchType === 'any' ) {
        allowed = permissions.includesSome(requiredPermissions);
    } else {
        allowed = permissions.includesAll(requiredPermissions);
    }

    const errorMessages = {
        default: <>
            <hr />
            <Alert severity={"error"} className={"push-down"}>
                <h3 className={"no-bold text-center"}>
                    You do not have permission to view this section.
                </h3>
            </Alert>
        </>,
        short: <>
            <span className={"no-bold text-danger"}>
                Access Denied
            </span>
        </>,
    };

    let errorMessage = props.errorMessage;

    if ( props.displayError ) {
        if ( !errorMessage && props.errorMessageType ) {
            if ( errorMessages[props.errorMessageType] ) {
                errorMessage = errorMessages[props.errorMessageType];
            }
        }
        if ( !errorMessage ) {
            errorMessage = errorMessages.default;
        }
    }

    if ( permissions.includes('fullPower') ) allowed = true;

    return (
        <>
            {permissions &&
            <>{allowed &&
            <>
                {props.children}
            </>
            }
                {!allowed &&
                <>
                    {fallback || errorMessage}
                </>
                }
            </>
            }
            {!permissions &&
            <>
            </>
            }
        </>
    );

};

AccessControl.propTypes = {
};

const mapStateToProps = state => ({
    globalState: state.globalState,
});

export default connect(mapStateToProps)(AccessControl);
